import { IsOptional, IsString, IsNumber, IsUrl, IsArray, ValidateNested, IsEmail, IsBoolean } from 'class-validator';
import { Type } from 'class-transformer';

export class InstagramMediaDto {
  @IsOptional()
  @IsString()
  public type?: 'image' | 'video';

  @IsOptional()
  @IsUrl()
  public url?: string;

  @IsOptional()
  @IsString()
  public media_id?: string;
}

export class InstagramPostDto {
    @IsOptional()
    @IsArray()
    @IsString({ each: true })
    public hashtags?: string[];

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    @Type(() => InstagramMediaDto)
    public media?: InstagramMediaDto[];
}

export class InstagramDetailsDto {
    @IsString()
    public userid: string;

    @IsOptional()
    @IsString()
    public username?: string;

    @IsOptional()
    @IsString()
    public location?: string;

    @IsOptional()
    @IsEmail()
    public email?: string;

    @IsOptional()
    @IsUrl()
    public profile_picture_hd?: string;

    @IsOptional()
    @IsString()
    public full_name?: string;

    @IsOptional()
    @IsNumber()
    public media_count?: number;

    @IsOptional()
    @IsNumber()
    public follower_count?: number;

    @IsOptional()
    @IsNumber()
    public following_count?: number;

    @IsOptional()
    @IsString()
    public biography?: string;

    @IsOptional()
    @IsBoolean()
    public video_content_creator?: boolean;

    @IsOptional()
    @IsString()
    public most_recent_post_date?: string;

    @IsOptional()
    @IsArray()
    @IsString({ each: true })
    public locations?: string[];

    // @IsOptional()
    // @IsArray()
    // @ValidateNested({ each: true })
    // @Type(() => InstagramTaggedUserDto)
    // public tagged?: InstagramTaggedUserDto[];

    // @IsOptional()
    // @ValidateNested()
    // @Type(() => InstagramReelsDto)
    // public reels?: InstagramReelsDto;

    @IsOptional()
    @IsNumber()
    public engagement_percent?: number;

    @IsOptional()
    @IsString()
    public engagement_percent_source?: string;

    @IsOptional()
    @IsArray()
    @IsString({ each: true })
    public hashtags?: string[];

    @IsOptional()
    @IsArray()
    @IsNumber({}, { each: true })
    public hashtags_count?: number[];

    @IsOptional()
    @IsArray()
    @ValidateNested({ each: true })
    @Type(() => InstagramPostDto)
    public post_data?: InstagramPostDto[];
}

export class InstagramMetadataDto {
    @IsOptional()
    @ValidateNested()
    @Type(() => InstagramDetailsDto)
    public instagram?: InstagramDetailsDto;
}
